export default __webpack_public_path__ + "static/media/cart-review-edit.8f9493e1.jpg";